import Link from "next/link";

export default function SuggestedResultItem({ item, cegjelzo = false }) {
	if(cegjelzo){
		return (
			<>
				{item.id ? (
					<Link href={`/company/${item.id}`}>
						<a>
							<strong>{item.name}</strong>
							<small> {item.address}</small>
						</a>
					</Link>
				) : null}
			</>
		);
	} else {
		const { City, StreetAndNum, Zip } = item.Address;
		const address = ` - ${Zip} ${City} ${StreetAndNum}`;
		return (
			<>
				{item.ShortTaxNumber ? (
					<Link href={`/company/${item.ShortTaxNumber}`}>
						<a>
							<strong>{item.Name}</strong>
							<small>{address}</small>
						</a>
					</Link>
				) : null}
			</>
		);
	}
}
